var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.12 13.5305C12.1 13.5305 12.07 13.5305 12.05 13.5305C12.02 13.5305 11.98 13.5305 11.95 13.5305C9.67998 13.4605 7.97998 11.6905 7.97998 9.51047C7.97998 7.29047 9.78998 5.48047 12.01 5.48047C14.23 5.48047 16.04 7.29047 16.04 9.51047C16.03 11.7005 14.32 13.4605 12.15 13.5305C12.13 13.5305 12.13 13.5305 12.12 13.5305ZM12 6.97047C10.6 6.97047 9.46998 8.11047 9.46998 9.50047C9.46998 10.8705 10.54 11.9805 11.9 12.0305C11.93 12.0205 12.03 12.0205 12.13 12.0305C13.47 11.9605 14.52 10.8605 14.53 9.50047C14.53 8.11047 13.4 6.97047 12 6.97047Z",
    fill: "#7E92A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9998 22.7503C9.30984 22.7503 6.73984 21.7503 4.74984 19.9303C4.56984 19.7703 4.48984 19.5303 4.50984 19.3003C4.63984 18.1103 5.37984 17.0003 6.60984 16.1803C9.58984 14.2003 14.4198 14.2003 17.3898 16.1803C18.6198 17.0103 19.3598 18.1103 19.4898 19.3003C19.5198 19.5403 19.4298 19.7703 19.2498 19.9303C17.2598 21.7503 14.6898 22.7503 11.9998 22.7503ZM6.07984 19.1003C7.73984 20.4903 9.82984 21.2503 11.9998 21.2503C14.1698 21.2503 16.2598 20.4903 17.9198 19.1003C17.7398 18.4903 17.2598 17.9003 16.5498 17.4203C14.0898 15.7803 9.91984 15.7803 7.43984 17.4203C6.72984 17.9003 6.25984 18.4903 6.07984 19.1003Z",
    fill: "#7E92A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#7E92A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.8aba8ed3904aca0acaadaf7e514bea1f.svg";
export { ForwardRef as ReactComponent };